module.exports = __webpack_public_path__ + "img/share.670c93f9.png";